import { Column, TableWithPagination, usePaginatedTable } from "@shared/primitive-components"
import { useMemo } from "react"
import { ResolvedFleetEntry } from "../../../../api/fleet"
import { buildMaybeObfuscatedHeader } from "../../../../components/Obfuscated"
import * as make from "./tableData/changedVehiclesTableData"
import { Data } from "./tableData/changedVehiclesTableData"

type Props = {
  changedEntries: ReadonlyArray<ResolvedFleetEntry>
}

export const CHANGED_ENTRIES_TABLE_DATA_TEST_ID = `changed_entries`

export const ChangedEntriesTable = ({ changedEntries }: Props) => {
  const data = useMemo(() => make.data(changedEntries), [changedEntries])
  const { page, dataCount, pagination } = usePaginatedTable(data)

  const columns = useMemo<ReadonlyArray<Column<Data>>>(
    () => [
      buildMaybeObfuscatedHeader<Data>(`registrationNumber`, `Vehicle Registration Number`, { type: `vrn` }),
      {
        Header: `Make`,
        accessor: `make`,
      },
      {
        Header: `Model`,
        accessor: `model`,
      },
      {
        Header: `ABI Group`,
        accessor: `abiGroupString`,
      },
      {
        Header: `On cover`,
        accessor: `onCoverDate`,
      },
      {
        Header: `Off cover`,
        accessor: `offCoverDate`,
      },
    ],
    []
  )

  return (
    <TableWithPagination<Data>
      data={page}
      dataTestIds={{ table: { root: CHANGED_ENTRIES_TABLE_DATA_TEST_ID } }}
      dataCount={dataCount}
      pagination={pagination}
      columns={columns}
    />
  )
}
